module.exports = __webpack_public_path__ + "img/编组@2x.5590f98d.png";